exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-loader{position:relative;width:100%;height:calc(100vh - 130px);background-color:#f3f3f3}.main-loader .spinner{position:absolute;top:calc(50% - 23px);left:calc(50% - 23px)}@media(min-width: 1160px){.main-loader{height:calc(100vh - 80px)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/components/main-loader/style.scss
// module id = 1297
// module chunks = 58